import type { AxiosResponse } from 'axios'

/**
 * Salva un file scaricato via axios (responseType: 'blob') preservando il
 * Content-Type e il filename (con estensione) inviati dal server.
 *
 * Bug ricorrente da evitare: `new Blob([res.data])` senza `type` azzera il
 * MIME type del blob già corretto restituito da axios, e usare un nome
 * "titolo" applicativo (es. "Architettonico") come filename senza
 * estensione fa sì che il file scaricato non abbia alcun tipo riconoscibile
 * — il sistema operativo/browser lo tratta spesso come testo semplice.
 */
export function downloadBlobResponse(res: AxiosResponse<Blob>, fallbackFilename: string) {
  const contentDisposition = res.headers?.['content-disposition'] || ''
  const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/)
  const filename = match ? decodeURIComponent(match[1]) : fallbackFilename

  const contentType = res.headers?.['content-type']
  const type = (typeof contentType === 'string' ? contentType : undefined) || res.data.type || 'application/octet-stream'
  const url = URL.createObjectURL(res.data.type === type ? res.data : new Blob([res.data], { type }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
